import styled from "styled-components";

export default styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 5px;

    width: 25px;
    height: 25px;

    font-weight: bolder;

    &.score-1 {
        background-color: ${(props) => props.theme.bqmqVoteScore1};
    }
    &.score-2 {
        background-color: ${(props) => props.theme.bqmqVoteScore2};
    }
    &.score-3 {
        background-color: ${(props) => props.theme.bqmqVoteScore3};
    }
    &.score-4 {
        background-color: ${(props) => props.theme.bqmqVoteScore4};
    }
    &.score-5 {
        background-color: ${(props) => props.theme.bqmqVoteScore5};
    }
`;
